import { createWebHistory, createRouter } from "vue-router";
import Connection from "../view/Connection.vue";
import Dividends from "../view/Dividends.vue";
import Financial from "../view/Financial.vue";
import Identity from "../view/Identity.vue";
import Login from "../view/Login.vue";
import ChangePassword from "../view/changepassword.vue";

const routes = [
  {
    path: "/",
    component: Dividends,
    name: "dividends",
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/connection",
    component: Connection,
    name: "connection",
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/financial",
    component: Financial,
    name: "financial",
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/identity",
    component: Identity,
    name: "identity",
    meta: {
      requiresAuth: true,
    },
  },
  { path: "/login", component: Login, name: "login" },
  {
    path: "/changepassword",
    component: ChangePassword,
    name: "changepassword",
  },
];

const router = createRouter({
  history: createWebHistory(),
  linkExactActiveClass: "active",
  routes,
});

router.beforeEach((to, from, next) => {
  if (
    to.matched.some((record) => {
      return record.meta.requiresAuth;
    })
  ) {
    // this route requires auth, check if logged in
    // if not, redirect to login page.
    if (localStorage.getItem("token") === null) {
      next({
        path: "/login",
      });
    } else {
      next();
    }
  } else {
    next(); // make sure to always call next()!
  }
});

export default router;
